import React                from 'react';
import ButtonChoice         from '../Fields/ButtonChoice';
import FieldValidation      from '../Fragments/FieldValidation';
import FieldError           from '../Fragments/FieldError';
import HelpText             from '../Fields/HelpText';
import CountrySelectElement from '../Fields/CountrySelectElement';

let Quote = require('../Managers/Quote');
let FaSpinner = require('react-icons/lib/fa/spinner');
let HttpService = require('../Managers/HttpService');

const Config = HttpService.getConfigForHost();
const CorAddressEntry = React.createClass({
    propTypes: {
        fieldNamePrefix: React.PropTypes.string.isRequired,
        pafLookup: React.PropTypes.bool.isRequired,
        postcodeFunction:  React.PropTypes.func,
        forceRerender:  React.PropTypes.func,
        helpText: React.PropTypes.string,
        question: React.PropTypes.string.isRequired
    },
    getInitialState() {
        let _isCountrySet = false;
        let _isUK = '';
        if (Quote.getCurrentAnswer('is_cor_address_uk') != undefined) {
            _isCountrySet = true;
            _isUK = Quote.getCurrentAnswer('is_cor_address_uk');
        }

        return {
            isHelpVisible: false,
            isValid: this.isValid(),
            hasError: false,
            pafLookupPostcode: false,
            pafResults: false,
            isUK: _isUK,
            isCountrySet: _isCountrySet,
            activeValue: this.getInitialStateForAddress(),
        };
    },
    childComponents : [],
    doValidation() {
        if (!this.state.isCountrySet || !Quote.hasAnswers(
                this.props.fieldNamePrefix+'_address_line1',
                this.props.fieldNamePrefix+'_address_postcode'
            )) {
            this.setState({
                hasError : true,
                errors : ["Please complete this question"]
            });
            return false;
        }
        this.setState({
            hasError : false,
            errors : []
        });
        return true;
    },

    setValue: function(event) {
        if (event.target.name === '_address_postcode') {
            let cleanPostcode = event.target.value.replace(/ /g,'').toUpperCase();

            Quote.set(this.props.fieldNamePrefix+event.target.name, cleanPostcode);
            if (this.props.postcodeFunction) {
                this.props.postcodeFunction(cleanPostcode);
            }
        } else {
            Quote.set(this.props.fieldNamePrefix+event.target.name, event.target.value);
        }

        Quote.set('cor', Quote.getCurrentAnswer('cor_address_postcode'));
    },

    setCountry: function(value) {
        this.setState({
            isUK: value,
            isCountrySet: true
        }, () => {
            this.doValidation();
        });
        // if we're in the UK, just delete it from the answers
        if (value == 'yes') {
            window.removeLocalStorageAnswer('country');
        }

    },

    isValid() {
        let countryIsValid = Quote.getCurrentAnswer('country');
        let corIsValid = Quote.hasAnswers(
            this.props.fieldNamePrefix+'_address_line1',
            this.props.fieldNamePrefix+'_address_postcode'
        );
        if (countryIsValid != 0 && countryIsValid != null && countryIsValid != undefined && corIsValid) {
            return true;
        } else {
            return false;
        }
    },

    setPafLookupPostcode: function(event) {
        let pc = event.target.value.replace(/\s+/g, '').toUpperCase();
        if (pc.length > 4) {
            this.setState({
                pafLookupPostcode: pc
            });
        }
    },

    pafLookup: function() {
        this.setState({
            isLoading: true
        });
        let _this = this;
        this.getQuoteRequest = $.ajax({
            type: Config.api.addressLookup.method,
            url: Config.api.addressLookup.url + this.state.pafLookupPostcode,
            dataType: 'json',
            success: function(result) {
                _this.setState({
                    isLoading: false,
                    pafResults: result,
                    hasError: false,
                });
            },
            error: function() {
                _this.setState({
                    isLoading: false,
                    pafResults: false,
                    hasError: true,
                    errors: ['An address could not be found for the above postcode']
                });
            }
        });
    },

    showManualEntry() {
        this.setState({
            showManualEntry : true
        });
        this.clearPafResults();
    },

    handleSelection: function(event) {
        let a = JSON.parse(event.target.value);
        if (a.Formatted == undefined) {
            return false;
        }

        let formatted = a.Formatted;

        if (a.town == a.county) {
            formatted = a.formatted;
            let countyIndex = formatted.lastIndexOf(a.county + ',');
            formatted = formatted.substring(countyIndex, 0).trim();
        }

        let townIndex = formatted.lastIndexOf(a.town + ',');
        let al1 = formatted.substring(townIndex, 0).trim();
        let firstline = al1.replace(/,\s*$/, "");
        let al2;

        let lastComma = firstline.lastIndexOf(",");
        if (lastComma > -1) {
            al2 = firstline.substring(lastComma + 1).trim();
            firstline = firstline.replace(al2, '');
            firstline = firstline.replace(/,\s*$/, "");
        } else {
            let firstSpace = firstline.indexOf(" ");
            al2 = firstline.substring(firstSpace + 1).trim();
            firstline = firstline.replace(al2, '');
            firstline = firstline.replace(/,\s*$/, "");
        }

        this.setAddress(firstline.trim(), al2.trim(), a.town.trim(), a.postcode);
        Quote.set('cor', Quote.getCurrentAnswer('cor_address_line1'));
        this.setState({ isValid: true });
    },

    getInitialStateForAddress() {
        if (Quote.getCurrentAnswer('cor_address_line1') !== null && Quote.getCurrentAnswer('cor_address_postcode') !== null) {
            let addressChunks = [];

            if (null != Quote.getCurrentAnswer('cor_address_line1')) {
                addressChunks.push(Quote.getCurrentAnswer('cor_address_line1'));
            }
            if (null != Quote.getCurrentAnswer('cor_address_line2')) {
                addressChunks.push(Quote.getCurrentAnswer('cor_address_line2'));
            }
            if (null != Quote.getCurrentAnswer('cor_address_line3')) {
                addressChunks.push(Quote.getCurrentAnswer('cor_address_line3'));
            }
            if (null != Quote.getCurrentAnswer('cor_address_postcode')) {
                addressChunks.push(Quote.getCurrentAnswer('cor_address_postcode'));
            }

            return addressChunks.join(', ');
        } else {
            return false;
        }
    },

    clearPafResults: function() {
        this.setState({
            pafResults: false,
            pafLookupPostcode: false,
            activeValue: false
        });
    },

    setAddress: function(address1, address2, address3, postcode) {
        Quote.set(this.props.fieldNamePrefix + '_address_line1', address1);
        if (undefined != address2 || null != address2) {
            Quote.set(this.props.fieldNamePrefix + '_address_line2', address2);
        }
        if (undefined != address3 || null != address3) {
            Quote.set(this.props.fieldNamePrefix + '_address_line3', address3);
        }
        Quote.set(this.props.fieldNamePrefix + '_address_postcode', postcode);
        this.setState({
            activeValue: this.getInitialStateForAddress(),
            isValid: true,
        }, () => {
            this.doValidation();
        });
    },

    render() {
        let dv = "0";
        let pafoptions = [];
        if (this.state.pafResults) {
            pafoptions.push(<option key={0} value="0">Please select...</option>);
            this.state.pafResults.forEach(function(i, index){
                pafoptions.push(<option key={index + 1} value={JSON.stringify(i)}>{i.Formatted.replace(/[,]/g, ', ')}</option>);
            }, this);

        } else if (this.state.activeValue) {
             pafoptions.push(<option key={0}>{this.state.activeValue}</option>);
        }
        return (
            <div>
                <ButtonChoice
                    question="Is your correspondence address in the UK?"
                    fieldName="is_cor_address_uk"
                    loadCachedValue={true}
                    children={[]}
                    questionId={0}
                    defaultValue={this.state.isUK}
                    helpText={this.props.helpText}
                    onSetValue={this.setCountry}
                    options={[
                        {
                            option_text: 'Yes',
                            option_value: 'yes'
                        },
                        {
                            option_text: 'No',
                            option_value: 'no'
                        }
                    ]} />

                {this.state.hasError && !this.state.isCountrySet ?
                    <question-row class={"no-border"}>
                        <question-main>
                            <FieldError errors={this.state.errors} />
                        </question-main>
                    </question-row>
                : null}

                {this.state.isCountrySet && !this.state.showManualEntry && this.state.isUK == 'yes' ?
                    <question-row>
                        <div className="question-main">
                            <div className="question-top">
                                <h2>
                                    {this.state.activeValue ?
                                        <span>Your correspondence address</span>
                                    :
                                        this.props.question
                                    }
                                </h2>
                            </div>

                            <div className="question-input">
                                <div className="question-input">
                                    {!this.state.activeValue ?
                                    <div className="input-group paf">
                                        <input type="text" ref="inputPostcode" name="pafsource" onBlur={this.setPafLookupPostcode} />
                                        <button className="btn btn-default" onClick={this.pafLookup}>Find my address {this.state.isLoading ? <FaSpinner className="spin" /> : ''}</button>
                                    </div>
                                    : null}
                                    {this.state.pafResults || this.state.activeValue ?
                                        <div className="clearfix address-selection">
                                        {
                                            this.state.pafResults ?
                                                <label>Please select your address from the list</label>
                                            : null
                                        }
                                            <select defaultValue={dv} onChange={this.handleSelection}>{pafoptions}</select>
                                            {this.state.activeValue ?
                                             <p className="pointer" onClick={this.showManualEntry}>Not correct?
                                              <span className="underline">Change your address</span></p> : null}
                                        </div>
                                    : null}
                                    {this.props.helpText ? <HelpText text={this.props.helpText} active={this.state.isHelpVisible} /> : null}
                                    {this.state.hasError ? <FieldError errors={this.state.errors} /> : null}
                                </div>

                            </div>
                        </div>
                        <div className="question-extra">
                            <FieldValidation isValid={this.state.isValid} hasError={this.state.hasError} />
                        </div>
                    </question-row>
                :null}

                {this.state.showManualEntry || this.state.isUK == 'no' ?
                <div>
                    <question-row>
                        <div className="question-main">
                            <div className="question-input">
                                <div className="address-entry-wrapper" id={this.props.fieldNamePrefix}>
                                    <label className="compound-component">Address Line 1</label>
                                    <input
                                        type="text"
                                        defaultValue={Quote.getCurrentAnswer(this.props.fieldNamePrefix+"_address_line1")}
                                        onBlur={this.setValue}
                                        id={this.props.fieldNamePrefix + '_address_line1'}
                                        name="_address_line1" />

                                    <label className="compound-component">Address Line 2</label>
                                    <input
                                        type="text"
                                        defaultValue={Quote.getCurrentAnswer(this.props.fieldNamePrefix+"_address_line2")}
                                        onBlur={this.setValue}
                                        id={this.props.fieldNamePrefix + '_address_line2'}
                                        name="_address_line2" />

                                    <label className="compound-component">Address Line 3</label>
                                    <input
                                        type="text"
                                        defaultValue={Quote.getCurrentAnswer(this.props.fieldNamePrefix+"_address_line3")}
                                        onBlur={this.setValue}
                                        id={this.props.fieldNamePrefix + '_address_line3'}
                                        name="_address_line3" />

                                    <label className="compound-component">Postcode</label>
                                    <input
                                        type="text"
                                        defaultValue={Quote.getCurrentAnswer(this.props.fieldNamePrefix+"_address_postcode")}
                                        onBlur={this.setValue}
                                        id={this.props.fieldNamePrefix + '_address_postcode'}
                                        name="_address_postcode" />
                                    {this.props.fieldNamePrefix == 'cor' && this.state.isUK == 'no' ?
                                        <CountrySelectElement question="Country" fieldName="country" />
                                    : null}
                                </div>
                            </div>
                        </div>
                        <div className="question-extra">
                            <FieldValidation isValid={this.state.isValid} hasError={this.state.hasError} />
                        </div>
                    </question-row>
                    {this.state.hasError ?
                        <question-row class="no-border">
                            <question-main>
                                <FieldError errors={this.state.errors} />
                            </question-main>
                        </question-row>
                    : null}
                    </div>
                : null}
            </div>
        );
    }
});

export default CorAddressEntry;



/** WEBPACK FOOTER **
 ** ./src/components/Fragments/CorAddressEntry.js
 **/